"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationProvider = PaginationProvider;
exports.usePaginationContext = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _reactSingletonContext = require("react-singleton-context");
var _usePagination = _interopRequireDefault(require("../hooks/usePagination"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["rowsPerPageOptions", "initialRowsPerPage"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PAGINATION_OPTIONS = [15, 25, 50];
const INITIAL_ROWS_PER_PAGE = 25;
const PaginationContext = (0, _reactSingletonContext.createRegisteredContext)('ContainerTablePaginationContext', undefined);
const usePaginationContext = () => {
  const context = React.useContext(PaginationContext);
  if (!context) {
    throw new Error('usePaginationContext should be used within a PaginationProvider');
  }
  return context;
};
exports.usePaginationContext = usePaginationContext;
/**
 * @ignore - internal component.
 */
function PaginationProvider(_ref) {
  let {
      rowsPerPageOptions,
      initialRowsPerPage
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const values = (0, _usePagination.default)({
    paginationOptions: rowsPerPageOptions || PAGINATION_OPTIONS,
    initialRowsPerPage: initialRowsPerPage || INITIAL_ROWS_PER_PAGE
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(PaginationContext.Provider, (0, _extends2.default)({
    value: values
  }, props));
}